import React from "react";
import { get } from "lodash";
import userLogo from "../../../assets/user-img.png";
import userClose from "../../../assets/user-close.png";
import organization from "../../../assets/userProfileIcons/building.png";
import call from "../../../assets/userProfileIcons/call.png";
import message from "../../../assets/userProfileIcons/message.png";
import { getLocalstorage } from "../../../helper";

export function TemplateUserProfile(props) {
  const userInfo = getLocalstorage("user");
  const isUserPMG = get(userInfo, "groupCategory") === "PMG";
  return (
    <div className="user-profile-wrapper">
      {get(props, "info.data") ? (
        <React.Fragment>
          <div className="upper-box">
            <div className="user-name-box">
              <img src={userLogo} className="user-logo" />
              <div>
                <h2>
                  {get(props.info, "data.name")}{" "}
                  {isUserPMG && <>({get(props.info, "data.userID")})</>}
                </h2>
                <div>{get(props.info, "data.designation")}</div>
              </div>
            </div>
            <img
              src={userClose}
              onClick={props.onClose}
              className="close-icon"
            />
          </div>
          <div className="lower-box">
            <div className="left-box">
              {get(props.info, "data.organization") ? (
                <div className="user-unit space-bottom">
                  <img src={organization} className="org-icon" />
                  <div>
                    Organization
                    <span>{get(props.info, "data.organization")}</span>
                  </div>
                </div>
              ) : null}
              {get(props.info, "data.mobileNumber") ? (
                <div className="user-unit">
                  <img src={call} className="call-icon" />
                  <div>
                    Phone
                    <span>{get(props.info, "data.mobileNumber")}</span>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="right-box">
              {get(props.info, "data.email") ? (
                <div className="user-unit">
                  <img src={message} className="mail-icon" />
                  <div>
                    Email
                    <span className="break-all">
                      {get(props.info, "data.email")}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>

            {/* {get(props.info, "data.address") ? (
              <p>
                <strong>Address: </strong> {get(props.info, "data.address")}{" "}
              </p>
            ) : null} */}
          </div>
        </React.Fragment>
      ) : (
        `No data found`
      )}
    </div>
  );
}
